import React, { MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import {
  Button,
  Icon,
  IconButton,
  TooltipContent,
  TooltipRoot,
  TooltipTrigger,
} from '@socialchorus/shared-ui-components';

interface IContentActionTranslate {
  isTranslated: boolean;
  handleClick?: MouseEventHandler;
  showText?: boolean;
  wideMode?: boolean;
  container?: HTMLElement | null;
}

const ContentActionTranslate: React.FC<IContentActionTranslate> = ({
  isTranslated,
  handleClick,
  showText = false,
  wideMode = false,
  container,
}) => {
  const className = cx('solar-shim', {
    'content__action--translated': isTranslated,
  });

  const { t } = useTranslation(undefined, { useSuspense: false });
  const translation_key = isTranslated
    ? 'content.see_original'
    : 'content.see_translation';

  const displayText = showText || wideMode;

  const actionLabel = t(translation_key);

  return displayText ? (
    <Button
      variant="text"
      onClick={handleClick}
      aria-label={actionLabel}
      label={t(translation_key)}
      leftIcon={<Icon>translate</Icon>}
      selected={isTranslated}
    />
  ) : (
    <TooltipRoot>
      <TooltipTrigger asChild>
        <IconButton
          className={className}
          aria-label={actionLabel}
          iconFilled={isTranslated}
          iconName="translate"
          onClick={handleClick}
        />
      </TooltipTrigger>
      <TooltipContent description={t(translation_key)} container={container} />
    </TooltipRoot>
  );
};

export { ContentActionTranslate };
